// Meja yang sedang dipakai / segera dipakai tamu reservasi, untuk pilihan meja di kasir cafe.
//  - Tamu sudah datang (status 'datang'): meja dianggap terpakai sampai reservasinya diselesaikan (tidak bergantung jam).
//  - Belum datang (status 'dikonfirmasi'): ditandai bila jam mulainya tinggal [menitSegera] menit lagi atau sudah lewat, selama
//    belum melewati jam selesai. Reservasi nanti sore tidak menandai meja untuk tamu yang datang sekarang.
// Kasir tetap boleh membuat pesanan di meja itu (tamu reservasi sering memesan lagi), tetapi diminta mengonfirmasi dulu.

import { semuaMejaReservasi } from './reservasi';

export const MENIT_SEGERA = 30;

const jam = (iso) => {
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

/**
 * @param daftar reservasi aktif (bentuk API: tableId, status, mulai, selesai, nama, jam, jamSelesai)
 * @returns objek { [tableId]: { r, jenis: 'datang' | 'segera' } }
 */
export const reservasiPerMeja = (daftar, sekarang = new Date(), menitSegera = MENIT_SEGERA) => {
  const t = new Date(sekarang).getTime();
  const hasil = {};
  const urut = [...(daftar || [])].sort((a, b) => new Date(a.mulai) - new Date(b.mulai));
  for (const r of urut) {
    const ids = semuaMejaReservasi(r); // meja utama + meja tambahan sama-sama ditandai
    if (!ids.length) continue;
    let jenis = null;
    if (r.status === 'datang') jenis = 'datang';
    else if (r.status === 'dikonfirmasi' && new Date(r.mulai).getTime() - menitSegera * 60000 <= t && t < new Date(r.selesai).getTime()) jenis = 'segera';
    if (!jenis) continue;
    for (const id of ids) {
      const ada = hasil[id];
      // tamu yang sudah duduk didahulukan; selain itu yang paling awal
      if (!ada || (ada.jenis === 'segera' && jenis === 'datang')) hasil[id] = { r, jenis };
    }
  }
  return hasil;
};

/** Teks pendek untuk daftar meja: "Reservasi Rafli 15:15–17:15 (sudah datang)". */
export const labelReservasiMeja = (info) => {
  if (!info) return '';
  const { r, jenis } = info;
  return `Reservasi ${r.nama} ${r.rentangJam || `${r.jam || jam(r.mulai)}–${r.jamSelesai || jam(r.selesai)}`} (${jenis === 'datang' ? 'sudah datang' : 'menunggu datang'})`;
};

/** Pesan konfirmasi saat kasir memilih meja yang ditandai reservasi. */
export const pesanKonfirmasiMeja = (namaMeja, info) => {
  const { r, jenis } = info;
  const status = jenis === 'datang' ? 'sudah datang dan sedang memakai meja ini' : 'akan datang dan meja ini disiapkan untuknya';
  return `Meja ${namaMeja} direservasi atas nama ${r.nama} (${r.jumlahOrang} orang, ${r.rentangJam || `${r.jam}–${r.jamSelesai}`}). Tamu ${status}. Lanjutkan membuat pesanan di meja ini?`;
};
